// @Version: 1.0.3
import { Injectable } from '@angular/core';
import { IErrorCodes } from './error-messages.model';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateDesignPipe } from '../../pipes/translate-design/translate-design.pipe';

UntilDestroy()
@Injectable()

export class ErrorMessagesService {

   constructor (private pTranslateDesign: TranslateDesignPipe) { 
   }

   public setErrorCodes (errorList: string, path: string): IErrorCodes {
      return Object.assign(JSON.parse(JSON.stringify(this.pTranslateDesign.transform(path))), this.createErrorMessageObject(errorList))
   }

   public createErrorMessageObject (errorMessages: string): IErrorCodes {
      const errorObject = {} as IErrorCodes;

      const errorMessagesArr: string[] = errorMessages.split(';');
      errorMessagesArr.forEach((element) => {
         const elementArr = element.split(':');
         if (elementArr.length == 2) errorObject[('errorCode' + elementArr[0].charAt(0).toUpperCase() + elementArr[0].slice(1)) as keyof typeof errorObject] = elementArr[1];
      });
      return errorObject;
   }
}
